<div>
  <div class="col-md-12 col-lg-12" style="min-height:50px;">
    <div class="col-sm-2"><h4><b>{{ "pages.createReceiptPage.shipperPage.shipper" | translate }}</b></h4></div>
    <div *ngIf="!isOpen">
      <div class="col-sm-4"><h4>&nbsp;</h4></div>
      <div class="col-sm-3"><h4 class="change {{enableChange? '':'disabled'}}" (click)="change()">{{ 'common.change' | translate}}</h4></div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-12 mrgin-lft mob-mrgin">
        <div class="details-container" *ngIf="!isOpen">    

          <div class="row" *ngIf="!isOpen">
            <div class="col-sm-3">{{ 'common.accountNumber' | translate}}</div>
            <div class="col-sm-3" title="{{shipper.accountNumber}}">{{shipper.accountNumber}}</div>
            <div class="col-sm-3">{{ 'common.mobile' | translate}}</div><div class="col-sm-3" title="{{shipper.mobile}}">{{shipper.mobile}}</div>
          </div>
          <div class="row">
            <div class="col-sm-3">{{ 'common.name' | translate}}</div>
            <div class="col-sm-3 text-elp" title="{{shipper.name}}">{{shipper.name}}</div>
            <div class="col-sm-3">{{ 'common.addressLine' | translate}}</div>
            <div class="col-sm-3 text-elp" title="{{shipper.addressLine}}">{{shipper.addressLine}}</div>
          </div>
          <div class="row">
          </div>
          <div class="row">
            <div class="col-sm-3 text-elp">{{ "pages.createReceiptPage.shipperPage.shippmentRef" | translate }}</div><div class="col-sm-3" title="{{shipper.shippmentReference}}">{{shipper.shippmentReference}}</div>
            <div class="col-sm-3 text-elp">{{ 'common.email' | translate}}</div><div class="col-sm-3"  title="{{shipper.email}}">{{shipper.email}}</div>
          </div>
    
          <div class="row">
            <div class="col-sm-3 text-elp">{{ "pages.createReceiptPage.shipperPage.shipperTax" | translate }}</div><div class="col-sm-3" title="{{shipper.taxNumber}}">{{shipper.taxNumber}}</div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<div class="form-container" *ngIf="isOpen">
  <div class="row" *ngIf="shipperTypes && shipperTypes.length>0">
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">Shipper Type</label>
        <select class="form-control" [ngModel]="shipper.shipperType" (ngModelChange)="onChangeFor($event)">
          <option *ngFor="let item of shipperTypes" value="{{item.id}}" >{{item.shipperType}}</option>
        </select>
        <span style="color: red;" id="shipperTypeSpan"></span> 
      </div>
    </div>
    <div class="col-md-4 col-sm-10" id="dynDiv">
     
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.accountNumber' | translate}}</label>
        <select class="form-control" [ngModel]="shipper.accountNumber" (ngModelChange)="shipper.accountNumber = $event">
          <option *ngFor="let item of userAccounts" value="{{item.Number}}" selected="{{item.IsDefault==true ? 'selected' : '' }}">{{item.Number}} - {{item.Name}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.mobile' | translate}}</label>
        <input class="form-control" #isFocus
               [(ngModel)]="shipper.mobile"
               autocomplete="disabled"
               (blur)="resolvePhone($event.target.value)" />
        <span [innerHtml]="validatorObject.Mobile.message"></span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.name' | translate}}</label>
        <input class="form-control"
               [(ngModel)]="shipper.name"
               autocomplete="disabled"
               (blur)="checkRequiredField('name')" />
        <span [innerHtml]="validatorObject.name.message"></span>
      </div>
      <!--<input type="text" class="form-control" [(ngModel)]="creditCardNumber" (keypress)="last4Digits($event)" />
      <span style="color:red" *ngIf="!validLast4Digits">Invalid Inputs</span>-->

    </div>
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.addressLine' | translate}}</label>
        <input class="form-control"
               autocomplete="disabled"
               [(ngModel)]="shipper.addressLine"
               (blur)="checkRequiredField('addressLine')" />
        <span [innerHtml]="validatorObject.addressLine.message"></span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ "pages.createReceiptPage.shipperPage.shipmentRef" | translate }}</label>
        <input class="form-control"
               [(ngModel)]="shipper.shippmentReference"
               autocomplete="disabled"
               #shippmentReference />
        <!--<span [innerHtml]="validatorObject.shippmentReference.message"></span>-->
      </div>
    </div>
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.email' | translate}}</label>
        <input class="form-control"
               [(ngModel)]="shipper.email"
               autocomplete="disabled"
               (blur)="checkRequiredField('email')"
               />
       <span [innerHtml]="validatorObject.email.message"></span> 
      </div>
    </div>
  </div>
  <div class="row" *ngIf="hasTax">
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ "pages.createReceiptPage.shipperPage.shipperTax" | translate }}</label>
        <input class="form-control"
               [(ngModel)]="shipper.taxNumber"
               autocomplete="disabled"
               (blur)="checkRequiredField('tax')"/>
       <span [innerHtml]="validatorObject.taxNumber.message"></span>
      </div>
    </div>
  </div>
  
  <div class="row">
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.ShipperReference' | translate}}</label>
        <input class="form-control"
               [(ngModel)]="shipper.ShipperReference"
               autocomplete="disabled"
               (blur)="checkRequiredField('name')" />
        <span [innerHtml]="validatorObject.name.message"></span>
      </div>
      <!--<input type="text" class="form-control" [(ngModel)]="creditCardNumber" (keypress)="last4Digits($event)" />
      <span style="color:red" *ngIf="!validLast4Digits">Invalid Inputs</span>-->

    </div>
    <div class="col-md-4 col-sm-10">
      <div class="form-group">
        <label class="control-label">{{ 'common.ShipperReference2' | translate}}</label>
        <input class="form-control" autocomplete="disabled" [(ngModel)]="shipper.ShipperReference2" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-sm-10">
        <div class="form-group">
          <button class="btn btn-primary" (click)="fillShipperInfo()">{{ 'common.next' | translate}}</button>
        </div>
      </div>
    </div>
</div>

